'use client';

import React from 'react';

interface TriggerClientProviderProps {
  children: React.ReactNode;
}

// Note: We don't actually need a provider for client-side Trigger.dev usage
// The publicAccessToken is passed directly to hooks like useRealtimeRun
export function TriggerClientProvider({ children }: TriggerClientProviderProps) {
  // No API key needed on client side - we use publicAccessToken from the backend
  return <>{children}</>;
}